<template>
  <input
    class="w-full border border-gray-100 rounded-lg"
    :disabled="disabled"
    :value="value"
    :inline="inline"
    :placeholder="placeholder"
    autocomplete="off"
  />
</template>

<script>
import format from 'date-fns/format'
import flatpickr from 'flatpickr'

import 'flatpickr/dist/themes/airbnb.css'

export default {
  props: {
    value: { type: String, default: '' },
    mode: { type: String, default: 'single', },
    availableDate: { type: Array, default: () => ([]) },
    placeholder: { type: String, default: () => format(new Date(), 'yyyy-MM-dd HH:mm') },
    allowInput: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    dateFormat: { type: String, default: 'Y-m-d' },
    defaultDate: { default: null, required: false },
    defaultHour: { type: Number, default: 12 },
    defaultMinute: { type: Number, default: 0 },
    disable: { type: Array, default: () => ([]) },
    twelveHourTime: { type: Boolean, default: false },
    enableTime: { type: Boolean, default: false },
    enableSeconds: { type: Boolean, default: false },
    firstDayOfWeek: { type: Number, default: 0 },
    inline: { type: Boolean, default: false },
    minDate: { type: [String, Date], default: null },
  },

  data: () => ({
    flatpickr: null,
  }),

  mounted () {
    this.$nextTick(() => {
      this.flatpickr = flatpickr(this.$el, {
        mode: this.mode,
        minDate: this.minDate,
        enableTime: this.enableTime,
        enableSeconds: this.enableSeconds,
        onClose: this.onClose,
        onChange: this.onChange,
        dateFormat: this.dateFormat,
        defaultDate: this.defaultDate,
        defaultHour: this.defaultHour,
        defaultMinute: this.defaultMinute,
        disable: this.disable,
        allowInput: this.allowInput,
        time_24hr: !this.twelveHourTime,
        inline: this.inline,
      })
    })
  },

  methods: {
    onChange () {
      this.$emit('input', this.$el.value)
    },
    onClose () {
      this.$emit('close')
    }
  },
}
</script>

<style>
.flatpickr-day.selected,
.flatpickr-day.startRange,
.flatpickr-day.endRange {
  background: theme('colors.blue.800') !important;
  border: theme('colors.blue.800') !important;
}

.flatpickr-day.today:not(.selected) {
  border-bottom-color: theme('colors.blue.800') !important;
}
.flatpickr-day.today:not(.selected):hover {
  border: 1px solid theme('colors.blue.800') !important;
}
.flatpickr-day.today:hover {
  background: theme('colors.blue.800') !important;
}

.flatpickr-day.selected.startRange {
  border-top-left-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}

.flatpickr-day.selected.endRange {
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
}

.flatpickr-day.selected.startRange + .endRange:not(:nth-child(7n+1)),
.flatpickr-day.startRange.startRange + .endRange:not(:nth-child(7n+1)),
.flatpickr-day.endRange.startRange + .endRange:not(:nth-child(7n+1)) {
    box-shadow: -10px 0 0 theme('colors.blue.800') !important;
}

.flatpickr-calendar:before, .flatpickr-calendar:after {
  display: none !important;
}
</style>
